import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { ZIndex } from "config/zIndex";
import styled from "styled-components";

export const DistributionOverlay = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: ${Spacing.xl}px;
  position: fixed;
  z-index: ${ZIndex.modalOverlay};

  ${mediaMax.mobile} {
    align-items: flex-start;
    padding: ${Spacing.md}px;
  }
`;

export const DistributionCard = styled.div`
  background: ${ColorV2.White};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 64px);
  min-height: min(880px, calc(100vh - 64px));
  overflow: hidden;
  padding: ${Spacing.xl}px;
  width: min(100%, 820px);

  ${mediaMax.mobile} {
    border-radius: 18px;
    max-height: calc(100vh - 32px);
    min-height: 0;
    padding: ${Spacing.lg}px ${Spacing.md}px;
  }
`;

export const DistributionScrollArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding-right: ${Spacing.xs}px;
`;

export const DistributionTitle = styled.h2`
  ${TypographyV2.h2}
  color: ${ColorV2.Blue1};
  margin: 0 0 ${Spacing.sm}px;
`;

export const DistributionDate = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  margin-bottom: ${Spacing.xl}px;
`;

export const SalesPeriodPanel = styled.section`
  background: ${ColorV2.Blue7};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  margin-bottom: ${Spacing.lg}px;
  padding: ${Spacing.md}px;
`;

export const DistributionSectionTitle = styled.h3`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
  margin: 0 0 ${Spacing.md}px;
`;

export const DistributionLabel = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const DistributionDescription = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const DistributionGrid = styled.div`
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: minmax(220px, 1fr) minmax(160px, 1fr) 120px;
  margin-top: ${Spacing.xl}px;

  ${mediaMax.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const DistributionHeaderCell = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const DistributionCell = styled.div`
  ${TypographyV2.b2}
  align-items: center;
  color: ${ColorV2.Blue1};
  display: flex;
  min-height: 44px;
`;

export const WorkerIdentity = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.sm}px;
  min-width: 0;
`;

export const WorkerAvatar = styled.div`
  ${TypographyV2.s1}
  align-items: center;
  background: ${ColorV2.Blue6};
  border-radius: 999px;
  color: ${ColorV2.Blue1};
  display: inline-flex;
  flex: 0 0 auto;
  height: 24px;
  justify-content: center;
  width: 24px;
`;

export const WorkerName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AmountInputShell = styled.label`
  ${TypographyV2.b2}
  align-items: center;
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 16px;
  color: ${ColorV2.Blue1};
  display: flex;
  height: 44px;
  justify-content: space-between;
  min-width: 112px;
  padding: 0 ${Spacing.sm}px;
`;

export const AmountInput = styled.input`
  ${TypographyV2.b2}
  background: transparent;
  border: 0;
  color: ${ColorV2.Blue1};
  min-width: 0;
  outline: none;
  width: 100%;
`;

export const AmountSuffix = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  flex: 0 0 auto;
`;

export const TeamAmount = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  justify-self: end;
`;

export const DistributionFooter = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: ${Spacing.xl}px;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const DistributionTotals = styled.div`
  display: flex;
  gap: ${Spacing.lg}px;

  ${mediaMax.mobile} {
    flex-direction: column;
    gap: ${Spacing.sm}px;
  }
`;

export const DistributionTotalText = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
  white-space: nowrap;
`;

export const DistributionActions = styled.div`
  display: flex;
  gap: ${Spacing.md}px;

  ${mediaMax.mobile} {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const DistributionStatus = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin-top: ${Spacing.sm}px;
`;
